module.exports = __webpack_public_path__ + "img/aboutus.44b0cb26.svg";